import { AdditionalLessonDTO } from 'types';
import { commonTexts, jsonObjectsTexts } from 'consts/text';
import { getAdditionalLessonPriceText } from 'utils/getAdditionalLessonPriceText';
import { EMPTY_VALUE_LABEL } from 'consts/labels/common';
import { additionalLessonPaymentMapper } from 'consts/additionalLessons/additionalLessonPaymentMapper';
import { additionalLessonSettlementMapper } from 'consts/additionalLessons/additionalLessonSettlementMapper';
import { settlementVatRateTypeLabels } from 'consts/settlementVatRates/settlementVatRateLabels';
import { settlementVatReleaseReasonLabels } from 'consts/settlementVatRates/settlementVatReleaseReasonLabels';

export const parseAdditionalLessonDTOIntoJsonObject: (
    additionalLessonDTO: AdditionalLessonDTO,
) => object = (additionalLessonDTO) => {
    const {
        free,
        paymentType,
        settlementType,
        price,
        courseName,
        configured,
        vatRate,
        vatReleaseReasonType,
        customVatReleaseReason,
    } = additionalLessonDTO;

    const formattedPrice =
        price && paymentType ? getAdditionalLessonPriceText(price, paymentType) : EMPTY_VALUE_LABEL;
    const paymentTypeLabel = paymentType
        ? additionalLessonPaymentMapper[paymentType]
        : EMPTY_VALUE_LABEL;
    const settlementTypeLabel = settlementType
        ? additionalLessonSettlementMapper[settlementType]
        : EMPTY_VALUE_LABEL;
    const vatRateTypeLabel = vatRate ? settlementVatRateTypeLabels[vatRate] : EMPTY_VALUE_LABEL;
    const vatReleaseReasonTypeLabel = vatReleaseReasonType
        ? settlementVatReleaseReasonLabels[vatReleaseReasonType]
        : EMPTY_VALUE_LABEL;

    return {
        [jsonObjectsTexts.additionalLessonDTO.fields.courseName]: courseName,
        [jsonObjectsTexts.additionalLessonDTO.fields.configured]: configured
            ? commonTexts.dataLabels.yes
            : commonTexts.dataLabels.no,
        [jsonObjectsTexts.additionalLessonDTO.fields.free]: free
            ? commonTexts.dataLabels.yes
            : commonTexts.dataLabels.no,
        [jsonObjectsTexts.additionalLessonDTO.fields.vatRate]: vatRateTypeLabel,
        [jsonObjectsTexts.additionalLessonDTO.fields.vatReleaseReasonType]:
            vatReleaseReasonTypeLabel,
        [jsonObjectsTexts.additionalLessonDTO.fields.customVatReleaseReason]:
            customVatReleaseReason,
        [jsonObjectsTexts.additionalLessonDTO.fields.price]: formattedPrice,
        [jsonObjectsTexts.additionalLessonDTO.fields.paymentType]: paymentTypeLabel,
        [jsonObjectsTexts.additionalLessonDTO.fields.settlementType]: settlementTypeLabel,
    };
};
